import React from 'react'
import { Dropdown } from 'semantic-ui-react'

const OPTIONS = [
  { text: 'Řadit podle ID vzestupně', value: 'asc' },
  { text: 'Řadit podle ID sestupně',  value: 'desc' },
]

export class DropdownSelect extends React.PureComponent {
  state = {
    value: null,
  }

  componentWillMount () {
    this.setState({
      value: this.props.value,
    })
  }

  onChange ({ value }) {
    this.setState({ value })
    // HACK - the form must submit after the field was rendered
    setTimeout(() => { this.input.form.submit() }, 10)
  }

  render () {
    return (
      <div>
        <Dropdown
          pointing
          closeOnBlur
          closeOnChange
          placeholder='Řazení'
          options={OPTIONS}
          value={this.state.value}
          onChange={(e, data) => this.onChange(data)}
        />

        <input
          type='hidden'
          value={this.state.value}
          name='search_item[dir]'
          ref={(c) => { this.input = c }}
        />
      </div>
    )
  }
}

export default DropdownSelect



// WEBPACK FOOTER //
// ./app/javascript/components/DropdownSelect.js